/**************************************************
 * Nombre:       Home_Pensamos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import seguro from '../../../Recursos/ic_seguro.svg'
import ahorro from '../../../Recursos/ic_ahorro.svg'
import seguridad from '../../../Recursos/ic_seguridad.svg'
import educacion from '../../../Recursos/ic_educacion.svg'
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Informacion from "../../Dialogos/Dialogo_Informacion";

const Home_Pensamos = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Informacion, titulo: 'Dejanos Contactarte'})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundColor: '#2EC2D830',
                        px: sCell ? 4 : 6,
                        py: sCell ? 4 : 8,
                        borderRadius: 10
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography
                                    sx={{color: '#10434A', fontSize: sCell ? 32 : 40, fontWeight: 600, lineHeight: 1.2}}
                                >
                                    Pensamos en ti, en los buenos y en los difíciles
                                    momentos</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                                <Typography
                                    sx={{color: '#010101', fontSize: 16, fontWeight: 400}}
                                >
                                    En Esperanza Hispana, tu esfuerzo también te protege. Por eso, tus ahorros incluyen
                                    un seguro de vida y accidentes que respalda tu dedicación y cuida de los
                                    tuyos
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 3}}>
                                <Button
                                    onClick={abrir}
                                >
                                    <Typography sx={{fontWeight: 500, pl: 3, pr: 2, color: '#fff'}}>Mas
                                        información</Typography>
                                    <span><IconButton
                                        sx={{backgroundColor: '#fff'}}><ArrowForward
                                        sx={{width: 16, height: 16, fill: '#010101'}}/></IconButton></span> </Button>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 3}}
                          sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}/>

                    <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={4}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{backgroundColor: '#fff', borderRadius: 8, p: 3}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                            <img src={item.img} width={80} height={'auto'}/>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'center', height: 40, mt: 1}}>
                                            <Typography
                                                sx={{textAlign: 'center', lineHeight: 1.2}}>{item.nombre}</Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            ))}

                        </Grid>
                    </Grid>

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Pensamos

const items = [
    {
        img: seguro,
        nombre: 'Seguro de vida'
    },
    {
        img: ahorro,
        nombre: 'Ahorro con propósito'
    },
    {
        img: seguridad,
        nombre: 'Seguridad y respaldo'
    },
    {
        img: educacion,
        nombre: 'Educación financiera'
    },
]